import React, {FC} from 'react';
import './VideoList.scss'
import ReactPlayer from "react-player";
import {IVideoItem} from "../../types/types";
import VideoItem from "./VideoItem";

interface IVideoList {
    list:Array<IVideoItem>
}

const VideoList:FC<IVideoList> = ({list}) => {
    return (
        <div className="videoList">
            {list.map(video=>
              <VideoItem key={video.id} video={video}/>
            )}
        </div>
    );
};

export default VideoList;